import { Navigate } from 'react-router-dom'
import { usePlanPermissions } from '../hooks/usePlanPermissions'
import { USE_NEW_PLAN_LOGIC } from '../components/utils/constant'

const PlanRestrictedRoute = ({ requiredPermission, children, redirectTo = '/' }) => {
  const { hasPermission, hasPlan, subscriptionExpired } = usePlanPermissions()

  if (!USE_NEW_PLAN_LOGIC) {
    return children
  }

  if (!hasPlan || subscriptionExpired || !hasPermission(requiredPermission)) {
    return <Navigate to={redirectTo} replace />
  }

  return children
}

export default PlanRestrictedRoute
